/** @format */
import config from 'config';
import React from 'react';
import MobileHeader from 'components/Layout/Header/MobileHeader';
import RegularHeader from 'components/Layout/Header/RegularHeader';

export default function Header(props) {
  const { t, isMobileView, dashboard } = props;

  const [show, setShow] = React.useState(false);

  const getButtonColor = (key) => {
    return key === 0 ? 'white' : 'pink';
  };

  const homepageUrl = config.app.friaMaklareWebOriginUrl;

  const buttonText = t('lang_header:buttons');
  const registerAsBrokerUrl = `${config.app.friaMaklareWebOriginUrl}/registrera`;
  const hideHeaderButtons =
    props.view === config.constants.views.broker_profile;

  return (
    <>
      {!dashboard &&
        <RegularHeader
          t={t}
          homepageUrl={homepageUrl}
          buttonText={buttonText}
          getButtonColor={getButtonColor}
          registerAsBrokerUrl={registerAsBrokerUrl}
          hideHeaderButtons={hideHeaderButtons}
        />
      }

      {isMobileView && (
        <MobileHeader
          t={t}
          homepageUrl={homepageUrl}
          buttonText={buttonText}
          show={show}
          setShow={setShow}
          getButtonColor={getButtonColor}
          registerAsBrokerUrl={registerAsBrokerUrl}
          hideHeaderButtons={hideHeaderButtons}
          dashboard={dashboard}
        />
      )}
    </>
  );
}
